import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '../../../atoms/PrimaryButton'
import SecondaryButton from '../../../atoms/SecondaryButton'
import FullScreenPopup from '../../../organisms/FullScreenPopup'
import ProductCommonContext from '../../../../context/common/commonContext'
import CustomDialog from '@/custom/components/organisms/Dialog/index'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../../common/components'
import CustomCommonContext from '../../../../../custom/context/common/commonContext'
import AuthContext from '../../../../../product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
import { Button, Link } from '@material-ui/core'
import Loaders from '../../../molecules/Loaders'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import ItemPropsList from './Item'
import { initialFunction, validationFunction, editValue } from './FieldFunction'

const BaseActionPage = (props) => {
    const data = props.data
    const arrayValue = props.arrayValue
    const { alldata_all_dropdown, allLocations, setSignupModal } = useContext(CustomCommonContext)
    const { allCountries, allStates, allCities } = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { isAuthenticated, user } = authContext
    const { t } = useTranslation()
    const [reload, setReload] = useState(false)
    const [arrayItemTrigger, SetArrayItemTrigger] = useState(false)
    const [itemPropsArrayErrors, SetItemPropsArrayErrors] = useState({})

    const [valueLoaded, setValueLoaded] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const [calculateFields, setCalculateFields] = useState([])
    const [initialEmptyValues, setInitialEmptyValues] = useState({})

    const [validationArray, setValidationArray] = useState({})
    const [mapDataValue, setMapDataValue] = useState([])
    const [mapDataValue1, setMapDataValue1] = useState([])
    const [mapDataValue2, setMapDataValue2] = useState([])

    const [togglePopup, setTogglePopup] = useState(false)
    const [additionalSubmit, setAdditionalSubmit] = useState('')
    const [toggleDialog, setToggleDialog] = useState(false)
    const [toggleDialogErr, setToggleDialogErr] = useState(false)
    console.log(arrayValue, 'array')
    const membership = props.membership

    const formik = useFormik({
        initialValues: initialValues,
        validateOnBlur: false,
        validationSchema: Yup.object().shape({ ...validationArray }, ['auction', 'buynow']),
        enableReinitialize: true,
        onSubmit: (values) => {
            if (props.customPopup && data?.status !== 'duplicate' && data?.status !== 'edit') {
                setToggleDialog(true)
            } else {
                formSubmitFunction(values)
            }
        },
    })

    const onAddItemArrayHandle = (option) => {
        // if (formik.values.itemPropStep === 0) {
        SetArrayItemTrigger(true)
        // }
        console.log(formik.values.itemPropStep, 'item step')
        formik.values.itemPropStep += 1
        formik.setFieldValue('itemPropStep', formik.values.itemPropStep)
    }

    const formSubmitFunction = (values) => {
        const value = values
        let tempMapData = mapDataValueRef.current
        if (props.listingWithoutRegister) {
            setSignupModal(true, true)
            return false
        }
        value.customdatetime = []
        tempMapData.map((data) => {
            if ((data.type === 'datetime' || data.type === 'date') && !value.pre_market_status) {
                if (value[data.name]) {
                    value[data.name] = moment(
                        value[data.name],
                        global.defaultDateTimeFormat
                            ? global.defaultDateTimeFormat
                            : 'MM-DD-YYYY h:mm a',
                    ).format()
                    value.customdatetime.push(data.name)
                }
            } else if (value.pre_market_status && value.pre_market_status !== 'preview') {
                if (data.type === 'datetime' || data.type === 'date') {
                    if (value[data.name]) {
                        value[data.name] = moment(
                            value[data.name],
                            global.defaultDateTimeFormat
                                ? global.defaultDateTimeFormat
                                : 'MM-DD-YYYY h:mm a',
                        ).format()
                        value.customdatetime.push(data.name)
                    }
                }
            } else if (data.type === 'numbercomma') {
                value[data.name] = value[data.name]
                    ? parseFloat(value[data.name].toString().replace(/[^0-9]/g, ''))
                    : ''
            }
        })

        if (data?.status === 'use') {
            value.id = 0
        }

        if (value.title === '') {
            setAlert('Title is required field', 'error')
        } else {
            props.actionFunction(value, value.market_status)
        }
    }

    useEffect(() => {
        if (props.handleMapDataValue) {
            props.handleMapDataValue(mapDataValue)
        }
    }, [mapDataValue, mapDataValue1, mapDataValue2])

    useEffect(() => {
        if (props.additionalFormikUpdate) {
            console.log(formik.values, 'formik update values')
            props.additionalFormikUpdate(formik.values)
        }
    }, [formik.values])

    // useEffect(() => {
    //     if (props.resetMapData) {
    //         if (props.mapDataValue) {
    //             setMapDataValue(props.mapDataValue)
    //             props.setResetMapData(false)
    //         }
    //     }
    // }, [props.resetMapData, props.mapDataValue])

    const subStateOptions = (data) => {
        let valueDrop = allStates
            .filter(
                (state) =>
                    (formik.values.country
                        ? formik.values.country.indexOf(state.countryCode) !== -1
                        : global.defaultCountry.indexOf(state.countryCode) !== -1) &&
                    global.ignoreStates.indexOf(state.isoCode) === -1,
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.isoCode
                return busCategoryChanged
            })
        if (global.defaultState) {
            const object1 = valueDrop.find((obj) => obj.show === global.defaultState)
            if (object1) {
                // Remove objects from their current positions
                valueDrop.splice(valueDrop.indexOf(object1), 1)
                valueDrop.unshift(object1)
            }
        }
        return valueDrop
    }

    const subCityOptions = (data) => {
        let valueDrop = allCities
            .filter((state) =>
                formik.values?.country && formik.values?.state
                    ? formik.values.country == state.countryCode &&
                      formik.values.state == state.stateCode
                    : formik.values.state
                    ? global.defaultCountry == state.countryCode &&
                      formik.values.state == state.stateCode
                    : false,
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.name
                return busCategoryChanged
            })
        return valueDrop
    }

    const subLevelOptions = (data) => {
        let valueDrop = alldata_all_dropdown
            .filter((subcat) => {
                if (
                    formik.values[data.sub_field] &&
                    parseInt(subcat.level, 10) === parseInt(data.sub_level, 10)
                ) {
                    if (
                        parseInt(subcat.active, 10) === 1 ||
                        (formik.values[data.name] && formik.values[data.name] === subcat.id)
                    ) {
                        return (
                            parseInt(formik.values[data.sub_field], 10) ===
                            parseInt(subcat.level_id, 10)
                        )
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
            .map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.description
                subCategoryChanged.value = subcat.id
                return subCategoryChanged
            })
        return valueDrop
    }

    const mapDataValueRef = useRef(mapDataValue)
    const errorArray = useRef([])

    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((data) => {
                if (data.type === 'select' && parseInt(data.sub_select, 10) === 1) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                    }
                }
                if (data.type === 'select' && data.name === 'state') {
                    data.options = subStateOptions(data)
                }
                if (data.type === 'select' && data.name === 'city') {
                    data.options = subCityOptions(data)
                }
            })
        }
    }, [formik.values])

    useEffect(() => {
        setValueLoaded(false)
        setInitialValues({})
        setInitialEmptyValues({})
        setMapDataValue([])
        setMapDataValue1([])
        setMapDataValue2([])
        let custom = props.customInitialValues

        if (arrayValue.length) {
            let mapValueArray = arrayValue
            const index = null

            let { tempMapData, show, calculateValues } = initialFunction(
                mapValueArray,
                alldata_all_dropdown,
                subLevelOptions,
                allCountries,
                subStateOptions,
                subCityOptions,
                allLocations,
                index,
                props,
            )
            setInitialValues({ ...custom, ...show })
            setInitialEmptyValues({ ...custom, ...show })
            setMapDataValue(tempMapData)

            if (props.customInBetween) {
                const midIndex = Math.floor(props.customInBetween)
                const firstHalf = tempMapData.slice(0, midIndex)
                const secondHalf = tempMapData.slice(midIndex)
                setMapDataValue1(firstHalf)
                setMapDataValue2(secondHalf)
            }

            setCalculateFields(calculateValues)

            setTimeout(() => {
                if (tempMapData.length) {
                    setValueLoaded(true)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])
    console.log(valueLoaded, 'valueLoad')

    useEffect(() => {
        setValidationArray({})

        if (arrayValue.length) {
            let mapValueArray = arrayValue

            let handle = validationFunction(mapValueArray, props.customValidation, t)
            console.log('handle', handle)
            setValidationArray(handle)
        }
    }, [arrayValue, props.customValidation])

    const resetForm = () => {
        setInitialValues(initialEmptyValues)
        if (props.customInitialValues && props.customInitialValues.itemPropStep > 0) {
            SetArrayItemTrigger(true)
        } else {
            SetArrayItemTrigger(false)
        }
        setReload(!reload)
    }

    const handleSingleProject = (edit_value) => {
        if (edit_value) {
            if (edit_value.record) {
                const auction = edit_value.record
                const index = null
                let objectPush = editValue(arrayValue, auction, index)
                if (props.customDynamicInput) {
                    objectPush.itemPropStep = objectPush.multiArrayObject.length
                }
                console.log(objectPush, 'objectP')
                setInitialValues(objectPush)
                setReload(!reload)
                if (Object.keys(objectPush).length) {
                    setTimeout(() => {
                        SetArrayItemTrigger(true)
                    }, 1000)
                }
            }
        }
    }

    useEffect(() => {
        console.log(initialValues, formik.values, 'initialll')
    }, [initialValues])

    useEffect(() => {
        if (isAuthenticated && user && user.admin) {
            if (
                (data.id && (data.status === 'edit' || data.status === 'editTemplate')) ||
                data?.status === 'duplicate'
            ) {
                formik.values.id = data.id
                props.editFunction(formik.values)
            } else if (data.status === 'use') {
                formik.values.id = data.id
                props.template_GetSingleValue(formik.values)
            } else if (data.status === 'new') {
                resetForm()
            }
        }
    }, [data.id, user, isAuthenticated])

    useEffect(() => {
        if (Object.keys(initialEmptyValues).length !== 0) {
            resetForm()
        }
    }, [initialEmptyValues])

    useEffect(() => {
        if (
            (data.id && (data.status === 'edit' || data.status === 'editTemplate')) ||
            data?.status === 'duplicate'
        ) {
            handleSingleProject(props.editValue)
            setReload(!reload)
        } else if (data.status === 'use') {
            handleSingleProject(props.template_SingleValue)
            console.log('useedit', props.template_SingleValue)
            setReload(!reload)
        } else if (data.status === 'new') {
            resetForm()
        }
    }, [props.editValue, data, props.template_SingleValue])

    const formSubmit = (type, additionalValue, additionField) => {
        setAdditionalSubmit(additionalValue)
        if (additionField) {
            formik.values[additionField] = additionalValue
        } else {
            formik.values.market_status = additionalValue
        }
        if (additionalValue == 'open') {
            if (formik.values.pre_market_status) {
                formik.setFieldValue('pre_market_status', '')
            }
        }

        if (type === 'submit') {
            if (props.validationPopup) {
                errorArray.current = []
                if (Object.keys(formik.errors).length) {
                    for (const key in formik.errors) {
                        if (formik.errors.hasOwnProperty(key)) {
                            mapDataValue.forEach((e) => {
                                if (e.name == key)
                                    errorArray.current.push({ ...e, errorVal: formik.errors[key] })
                            })
                        }
                    }
                    setToggleDialogErr(true)
                }
                formik.submitForm()
            } else {
                formik.submitForm()
            }
        } else {
            formSubmitFunction(formik.values)
        }
    }
    const handlePopup = () => {
        setTogglePopup(true)
    }
    const changePopupStatus = () => {
        setTogglePopup(!togglePopup)
    }

    //handling type display
    const dynamicOprator = (data, operator) => {
        let valueTemp = 0
        switch (operator) {
            case '*':
                valueTemp = data.reduce((a, b) => {
                    return formik.values[a] * formik.values[b]
                })
                break
            case '+':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) + Number(formik.values[b])
                })
                break
            case '-':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) - Number(formik.values[b])
                })
                break
            case '/':
                valueTemp = data.reduce((a, b) => {
                    return Number(formik.values[a]) / Number(formik.values[b])
                })
                break
            case '=':
                valueTemp = formik.values[data]
                break
            default:
                break
        }

        return valueTemp
    }
    useEffect(() => {
        if (calculateFields.length) {
            calculateFields.map((buscat) => {
                formik.values[buscat.name] = dynamicOprator(
                    buscat.calculate_value.value,
                    buscat.calculate_value.operator,
                )
            })
        }
    }, [formik.values])

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }
    const changeDialogStatusErr = () => {
        setToggleDialogErr(!toggleDialogErr)
    }

    if (props.populateValidation) {
        useEffect(() => {
            if (Object.keys(props.customValidation).length)
                formik.validateForm().then((errors) => {
                    if (Object.keys(errors).length) {
                        formik.handleSubmit()
                    }
                })
        }, [props.customValidation, validationArray])
    }

    return (
        <>
            {valueLoaded ? (
                <>
                    {Object.keys(formik.values).length !== 0 ? (
                        <>
                            <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                                {props.customInBetween ? (
                                    <>
                                        <div className="row">
                                            {mapData(
                                                { formik, data: mapDataValue1 },
                                                false,
                                                false,
                                                t,
                                            )}
                                        </div>
                                        {props.customDynamicInput ? (
                                            <>
                                                <div className="row">
                                                    <ItemPropsList
                                                        formik={formik}
                                                        trigger={arrayItemTrigger}
                                                        errors={itemPropsArrayErrors}
                                                        resetTrigger={SetArrayItemTrigger}
                                                        alldata_all_dropdown={alldata_all_dropdown}
                                                        allCountries={allCountries}
                                                        subStateOptions={subStateOptions}
                                                        subCityOptions={subCityOptions}
                                                        allLocations={allLocations}
                                                        isDelete={props.isDelete}
                                                        disableEditing={props.disableEditing}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 moreBtnPRT">
                                                        <Button
                                                            className="addMore"
                                                            type="button"
                                                            onClick={() => onAddItemArrayHandle(1)}
                                                        >
                                                            <span className="material-icons">
                                                                add_circle
                                                            </span>
                                                            {t('Add Damage')}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}

                                        {mapDataValue2.length ? (
                                            <div className="row">
                                                {mapData(
                                                    { formik, data: mapDataValue2 },
                                                    false,
                                                    false,
                                                    t,
                                                )}
                                            </div>
                                        ) : null}
                                    </>
                                ) : (
                                    <>
                                        <div className="row">
                                            {mapData(
                                                { formik, data: mapDataValue },
                                                false,
                                                false,
                                                t,
                                            )}
                                        </div>

                                        {props.filterCharity &&
                                        Object.keys(props.filterCharity).length ? (
                                            <div className="indivualCharityContainer row">
                                                <div className="col-md-4 mb-2">
                                                    <label>Charity Name</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.fundraiser_name}
                                                    </span>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label>Postcode</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.postcode}
                                                    </span>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label>Register Number</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.reg_number}
                                                    </span>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label>town</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.town}
                                                    </span>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label>Country Code</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.country_code}
                                                    </span>
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <label>Charity URL</label>
                                                    <span className="chvlus">
                                                        <Link
                                                            target="_blank"
                                                            href={props.filterCharity.jg_url}
                                                        >
                                                            {props.filterCharity.jg_url}
                                                        </Link>
                                                    </span>
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <label>Charity Logo</label>
                                                    <span className="chvlus">
                                                        <img
                                                            className="logo"
                                                            alt="Charity Logo"
                                                            src={props.filterCharity.logo_download}
                                                        />
                                                    </span>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <label>Description</label>
                                                    <span className="chvlus">
                                                        {props.filterCharity.mission_statement}
                                                    </span>
                                                </div>
                                            </div>
                                        ) : null}
                                        {props.customDynamicInput ? (
                                            <>
                                                <div className="row">
                                                    <ItemPropsList
                                                        formik={formik}
                                                        trigger={arrayItemTrigger}
                                                        errors={itemPropsArrayErrors}
                                                        resetTrigger={SetArrayItemTrigger}
                                                        alldata_all_dropdown={alldata_all_dropdown}
                                                        allCountries={allCountries}
                                                        subStateOptions={subStateOptions}
                                                        subCityOptions={subCityOptions}
                                                        allLocations={allLocations}
                                                        isDelete={props.isDelete}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 moreBtnPRT">
                                                        <Button
                                                            className="addMore"
                                                            type="button"
                                                            onClick={() => onAddItemArrayHandle(1)}
                                                        >
                                                            <span className="material-icons">
                                                                add_circle
                                                            </span>
                                                            {t('Add Damage')}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                    </>
                                )}

                                <div className="actionButton mt-3 d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        id="baseAction_cancel"
                                        label={props.BackBtnLabel ? props.BackBtnLabel : 'Cancel'}
                                        onClick={
                                            props.cancelpopup ? handlePopup : props.cancelFunction
                                        }
                                        disabled={props.backBtnDisabled}
                                    />
                                    {props.buttonAction.map((data, index) => (
                                        <>
                                            {data.style === 'primary' ? (
                                                <>
                                                    <PrimaryButton
                                                        id="base_submit"
                                                        onClick={() => {
                                                            formSubmit(
                                                                data.type,
                                                                data.additionalValue,
                                                                data.additionalField,
                                                            )
                                                        }}
                                                        type="button"
                                                        label={data.label}
                                                    />
                                                </>
                                            ) : data.style === 'secondary' ? (
                                                <SecondaryButton
                                                    id="baseAction_draft"
                                                    onClick={() => {
                                                        formSubmit(
                                                            data.type,
                                                            data.additionalValue,
                                                            data.additionalField,
                                                        )
                                                    }}
                                                    type="button"
                                                    label={data.label}
                                                />
                                            ) : null}
                                        </>
                                    ))}
                                </div>
                            </form>
                        </>
                    ) : null}
                </>
            ) : null}
            <CustomDialog
                open={togglePopup}
                handleClose={() => setTogglePopup(false)}
                title={t('Alert!')}
                className="alertDialog"
                function={changePopupStatus}
            >
                <h2>{t('Are you sure you want to cancel')}</h2>
                <div className="actionWrapper">
                    <SecondaryButton
                        id="baseActionpopup_cancel"
                        label={props.BackBtnLabel ? props.BackBtnLabel : 'Cancel'}
                        onClick={() => {
                            setTogglePopup(false)
                        }}
                        disabled={props.backBtnDisabled}
                    />
                    <PrimaryButton
                        id="baseaction_popup_cancel"
                        onClick={props.cancelFunction}
                        type="button"
                        label={t('ok')}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={t('confirm_bid')}
                open={toggleDialog}
                className="alertDialog"
                function={changeDialogStatus}
            >
                <h4>
                    {t('Kindly note')} {formik.values?.auction ? t('auction') : t('direct_sales')}{' '}
                    {t(
                        "ad's will be deducted from your Active susbcription plan upon confirmation",
                    )}
                    !
                </h4>
                <h3>{t('Current Balance')}:</h3>
                <h4>
                    {t('auctions')} -
                    {user?.membership_period == 'yearly'
                        ? membership?.auctions_year - props.activeAuctionCount
                        : membership?.monthly_auction - props.activeAuctionCount}
                </h4>
                <h4>
                    {t('direct_sales')} -
                    {user?.membership_period == 'yearly'
                        ? membership?.users_limit_to - props.activeBuynowCount
                        : membership?.monthly_lots - props.activeBuynowCount}
                </h4>
                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => setToggleDialog(false)}>
                        {t('cancel')}
                    </Button>
                    <PrimaryButton
                        id="confirm_bid_submit"
                        onClick={() => {
                            setToggleDialog(false)
                            formSubmitFunction(formik.values)
                        }}
                        type="button"
                        label={t('submit')}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                // title={t('Form_Validation')}
                open={toggleDialogErr}
                function={changeDialogStatusErr}
                handleClose={changeDialogStatusErr}
                className="validationErrorDialog"
            >
                <>
                    <div className="modalHeader">
                        <h4 className="tit">¡Atención!</h4>
                        <h4 className="">
                            Debe completar el/los campo(s) requerido(s) para publicar
                        </h4>
                    </div>
                    <ol>
                        {errorArray.current.map((e) =>
                            e.label != ' ' ? (
                                <li>
                                    {e.label}:<span>{e.errorVal}</span>
                                </li>
                            ) : null,
                        )}
                    </ol>
                </>
            </CustomDialog>
        </>
    )
}

export default BaseActionPage
